<template>
    <n-card title="Associações" class="p-4">
        <div class="flex justify-between mb-4">
            <n-select v-model:value="cd_tecnico" placeholder="Técnico" :options="tecnicos" label-field="nm_tecnico" value-field="cd_tecnico" filterable />
        </div>
        <n-list>
            <n-list-item v-for="agendamento in agendamentos">
                <n-thing :title="`ID: ${agendamento.cd_agendamento} - ${agendamento.nm_endereco}`" content-style="margin-top: 10px;">
                    <template #avatar>
                        <n-avatar>
                            <n-button circle secondary :type="agendamento.checked?'success':'info'" @click="checkItem(agendamento)">{{ agendamento.checked?'✅':'❌'}}</n-button>
                        </n-avatar>
                    </template>
                    <div class="info-grid">
                        <p><strong>ID:</strong> {{ agendamento.cd_agendamento }}</p>
                        <p><strong>Cidade:</strong> {{ agendamento.nm_cidade }}</p>
                        <p><strong>Estado:</strong> {{ agendamento.nm_estado }}</p>
                        <p><strong>Região Logística:</strong> {{ agendamento.nm_regiao_logistica }}</p>
                        <p><strong>Status:</strong> {{ agendamento.nm_status_agendamento  }}</p>
                        <p><strong>Observações:</strong> {{ agendamento.nm_observacoes }}</p>
                    </div>
                </n-thing>
            </n-list-item>
        </n-list>
    </n-card>
</template>
<script>
import api from '@/api/api';

export default{
    data(){
        return{
            agendamentos:[],
            tecnicos: [],
            cd_tecnico: null,
            agendamentos_selecionados: []
        }
    },
    created(){
        this.carregaChamados()
    },
    methods:{
        async carregaChamados(){
            this.tecnicos = await api.get('tecnico')
            const [res1, res2] = await Promise.all([
              api.get('agendamento/status/1'),
              api.get('agendamento/status/3')
            ]);
            this.agendamentos = [...res1, ...res2];
            this.agendamentos = this.agendamentos.map(item => ({
                ...item,
                checked: false
            }));
            console.log(this.agendamentos)
        },
        checkItem(agendamento){
            agendamento.checked = !agendamento.checked
        },
        salvarAgendamentos(){

        }
    }
}
</script>
<style>
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.3rem 1rem;
  font-size: 0.9rem;
}
</style>